import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-charcoal px-4" data-testid="admin-login-page">
      <form onSubmit={submit} className="glass copper-glow w-full max-w-sm rounded-2xl p-8">
        <p className="eyebrow mb-2">Owner Only</p>
        <h1 className="font-serif text-2xl text-cream">Content Admin</h1>
        <label className="mt-8 block">
          <span className="text-[10px] font-mono uppercase tracking-[0.2em] text-copper-400">Email</span>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            data-testid="admin-login-email-input" autoComplete="email"
            className="mt-1 w-full rounded-lg border border-white/10 bg-charcoal-800 px-4 py-3 text-sm text-cream focus:border-copper focus:outline-none" />
        </label>
        <label className="mt-4 block">
          <span className="text-[10px] font-mono uppercase tracking-[0.2em] text-copper-400">Password</span>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            data-testid="admin-login-password-input" autoComplete="current-password"
            className="mt-1 w-full rounded-lg border border-white/10 bg-charcoal-800 px-4 py-3 text-sm text-cream focus:border-copper focus:outline-none" />
        </label>
        <button type="submit" disabled={busy} data-testid="admin-login-submit-btn"
          className="mt-6 w-full rounded-full bg-copper py-3 text-xs font-mono uppercase tracking-[0.18em] text-charcoal transition-colors hover:bg-copper-300 disabled:opacity-60">
          {busy ? "Signing in…" : "Sign In"}
        </button>
        <Link to="/" className="mt-5 block text-center text-xs text-cream-dim hover:text-copper-300" data-testid="admin-login-back-link">← Back to site</Link>
      </form>
    </main>
  );
}
